import { Component, OnInit, Inject } from '@angular/core';
import { Message } from 'primeng/primeng';

import { MainService } from '../../main.service';
import { HomeService } from '../../home/home.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-components-to-bundle',
  templateUrl: './add-components-to-bundle.component.html',
  styleUrls: ['../../../style.scss', './add-components-to-bundle.component.css']
})
export class AddComponentsToBundleComponent implements OnInit {

  componentOptions: {};
  bundleOptions: {};
  filteredComponentMultiple: any[];
  componentList: any[];
  selectedCompoenets: any;
  clickedOnce: boolean;

  msgs: Message[];

  userEmail = localStorage.getItem('userEmail');
  responce: any;

  constructor(
    private mainService: MainService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddComponentsToBundleComponent>,
    private homeService: HomeService,
    private router: Router,) {

  }

  filterCompoenentMultiple(event) {
    let query = event.query;
    if (this.componentOptions != undefined) {
      this.mainService.getComponents(this.componentOptions).then(comp => {
        this.filteredComponentMultiple = this.filterComponent(query, comp);
        if (this.filteredComponentMultiple.length == 0) {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Please Enter a correct component name !' });
        }
      });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Please Select a Project First !' });
    }
  }

  sendBundleData() {
    this.clickedOnce = true;
    var versionsList = '';
    var idList = '';
    var componentList = '';
    for (var i = 0; i < this.selectedCompoenets.length; i++) {
      versionsList = ",";
      idList = ",";
      componentList = componentList + this.selectedCompoenets[i].id + ",";
    }

    this.bundleOptions = {
      bundle_id: this.data.b_id,
      version: versionsList,
      release_id: idList,
      component: componentList,
      connect: componentList
    };

    console.log("send bundle data: ",this.bundleOptions);

    this.homeService.sendReleaseBundleData(this.bundleOptions).then(res => {
      this.responce = res;

      if (this.responce.status == 'sent') {

        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Components Added' });

        this.clickedOnce = true;

        setTimeout(() => {
          this.selectedCompoenets = [];
          this.onClose();
        },
          700);
      } else {
        console.log(this.responce);
        this.clickedOnce = false;
      }

    });

  }

  filterComponent(query, comp: any[]): any[] {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    for (let i = 0; i < comp.length; i++) {
      let component = comp[i];
      if (component.component.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(component);
      }
    }
    return filtered;
  }

  getComponents() {
    this.mainService.getComponents(this.componentOptions).then(components => {
      this.componentList = components;
    });

  }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

    this.componentOptions = {
      id: this.data.project_id,
      list: '',
      user: this.userEmail
    };

    this.getComponents();

  }

}
